import React, { Component } from "react";
import { observer } from "mobx-react";
import GoogleLogin, {
    GoogleLoginResponse,
    GoogleLoginResponseOffline,
} from "react-google-login";
import styled from "styled-components";

import { Typography } from "@formant/ui/component/common/Typography";

import GoogleLogo from "../../static/images/google-logo.svg";
import { StandardButton } from "../common/StandardButton";

interface IGoogleButtonProps {
    darkMode?: boolean;
    onGoogleLoginSuccess: (
        code: GoogleLoginResponse | GoogleLoginResponseOffline,
    ) => void;
}

@observer
export class GoogleButton extends Component<IGoogleButtonProps> {
    public render() {
        const { onGoogleLoginSuccess } = this.props;
        return (
            <GoogleLogin
                className="google-button"
                clientId="413966645161-pgspsbrg68a9pp19f6bf9545elklg40o.apps.googleusercontent.com"
                buttonText="SIGN IN WITH GOOGLE"
                onSuccess={onGoogleLoginSuccess}
                cookiePolicy="single_host_origin"
                render={props => (
                    <GoogleButtonStyled onClick={props.onClick}>
                        <img src={GoogleLogo} />
                        <Typography type="body" color="white">
                            SIGN IN WITH GOOGLE
                        </Typography>
                    </GoogleButtonStyled>
                )}
            />
        );
    }
}

const GoogleButtonStyled = styled(StandardButton)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: var(--color-border-tertiary);
    border-radius: 6.25rem;
    border: none;
    text-transform: none;
    letter-spacing: 0.847px;

    img {
        margin-right: 0.625rem;
    }
`;
